// extracted by mini-css-extract-plugin
export default {"shake":"alert_shake__UUaA8"};